import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["templateId", "startIcon", "endIcon", "onClick", "download", "href", "hrefLang", "media", "ping", "rel", "target", "type", "referrerPolicy", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useTemplateOpener } from '@miro-site/core';
import { useKeyboardNavigationFlag } from '../../utils';
import ButtonStyled from './Button.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable-next-line */
// @ts-ignore
var LoaderIcon = function LoaderIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    title: "Loading"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 12.5523 1.55228 13 1 13C0.447716 13 0 12.5523 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C11.4477 24 11 23.5523 11 23C11 22.4477 11.4477 22 12 22Z"
    })
  }));
};

var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  useKeyboardNavigationFlag();

  var _useTemplateOpener = useTemplateOpener(),
      setTemplateId = _useTemplateOpener.setTemplateId;

  var templateId = props.templateId,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      onClick = props.onClick,
      download = props.download,
      href = props.href,
      hrefLang = props.hrefLang,
      media = props.media,
      ping = props.ping,
      rel = props.rel,
      target = props.target,
      type = props.type,
      referrerPolicy = props.referrerPolicy,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var anchorProps = {
    download: download,
    href: href,
    hrefLang: hrefLang,
    media: media,
    ping: ping,
    rel: rel,
    target: target,
    type: type,
    referrerPolicy: referrerPolicy
  };
  var Component = 'button';

  if (anchorProps.href) {
    Component = 'a';
  } // If `templateId` is specified, we will take over the
  // click handler in order to trigger the account picker


  var handleOnClick = function handleOnClick(e) {
    if (templateId) {
      setTemplateId(templateId);
      return;
    }

    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  return /*#__PURE__*/_jsx(ButtonStyled, _objectSpread(_objectSpread({
    ref: ref,
    onClick: handleOnClick,
    startIcon: !!startIcon,
    endIcon: !!endIcon,
    asChild: true
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs(Component, _objectSpread(_objectSpread({}, anchorProps), {}, {
      children: [startIcon, /*#__PURE__*/_jsx("span", {
        children: children
      }), endIcon, props.loading && /*#__PURE__*/_jsx(LoaderIcon, {
        "data-button-loader": true
      })]
    }))
  }));
});
Button.displayName = 'Button';
export default Button;